import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import SignupModal from './components/SignupModal';
import HistoryPage from './components/HistoryPage';
import Navbar from './components/Navbar';
import { onAuthStateChanged, checkForEmailSignIn } from './services/firebase';
import StructuredData from './components/StructuredData';
import './App.css';
import Navigation from './components/Navigation';
import Blog from './components/Blog';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

function App() {
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [calculationCount, setCalculationCount] = useState(0);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged((user) => {
      setIsAuthenticated(!!user);
      setUserEmail(user ? user.email : null);
    });
    
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    // Check if the user is coming back from an email link
    const handleEmailSignIn = async () => {
      try {
        const user = await checkForEmailSignIn();
        if (user) {
          console.log('User signed in via email link:', user.email);
          // You can add additional logic here if needed
        }
      } catch (error) {
        console.error('Error handling email sign-in:', error);
      }
    };
    
    handleEmailSignIn();
  }, []);

  const handleCalculate = () => {
    setCalculationCount(prev => prev + 1);
  };

  const handleShowSignupModal = () => {
    setShowSignupModal(true);
  };

  const handleCloseSignupModal = () => {
    setShowSignupModal(false);
  };

  const handleSignup = (email) => {
    setUserEmail(email);
    setIsAuthenticated(true);
    setShowSignupModal(false);
  };

  return (
    <Router>
      <div className="App">
        <StructuredData />
        <Navigation 
          isLoggedIn={isAuthenticated} 
          userEmail={userEmail} 
          onShowSignupModal={handleShowSignupModal}
        />
        
        <Routes>
          <Route path="/" element={
            <HomePage 
              isRegistered={isAuthenticated} 
              userEmail={userEmail} 
              onShowSignupModal={handleShowSignupModal}
              onCalculate={handleCalculate}
              hasProvidedEmail={localStorage.getItem('userProvidedEmail') !== null}
            />
          } />
          
          <Route path="/history" element={
            <HistoryPage 
              isAuthenticated={isAuthenticated} 
              userEmail={userEmail}
              calculationCount={calculationCount}
            />
          } />
          
          <Route path="/blog" element={<Blog />} />
          
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
        
        {showSignupModal && (
          <SignupModal 
            onClose={handleCloseSignupModal} 
            onSignup={handleSignup} 
          />
        )}
      </div>
    </Router>
  );
}

export default App; 